import { Component, OnInit } from '@angular/core';
import { MultipathToolElem, MultipathToolService } from 'src/app/services/multipath-tool.service';
import { ToolsControlService } from 'src/app/services/tools-control.service';
import { MenuManagementService } from 'src/app/menu/services/menu-management.service';
import { TabsService } from 'src/app/services/tabsService';
import { VicentyToolControlService } from 'src/app/services/vicenty-tool-control.service';
import { Feature } from 'ol';



@Component({
  selector: 'app-multipath-tool',
  templateUrl: './multipath-tool.component.html',
  styleUrls: ['./multipath-tool.component.scss'],
  standalone: false
})
export class MultipathToolComponent implements OnInit {

  constructor(
    public multipathToolService : MultipathToolService,
    public toolsService : ToolsControlService,
    public menuController : MenuManagementService,
    public tabsService: TabsService,
  ) { }

  ngOnInit(): void {
  }


  add(){
    var selected = new MultipathToolElem();

    if(this.multipathToolService.selectedIndex != null){
      selected.latitude = this.multipathToolService.multipathElems[this.multipathToolService.selectedIndex].latitude;
      selected.longitude = this.multipathToolService.multipathElems[this.multipathToolService.selectedIndex].longitude;
      selected.delay = this.multipathToolService.multipathElems[this.multipathToolService.selectedIndex].delay;
    }


    this.multipathToolService.multipathElems.push(selected);
    if(this.multipathToolService.selectedIndex != null)
      this.multipathToolService.unSelectFeature(this.multipathToolService.selectedIndex);
    this.multipathToolService.selectedIndex = this.multipathToolService.multipathElems.length-1;
  }
  check(i:number){
    if(this.multipathToolService.selectedIndex == i){
      this.multipathToolService.selectedIndex = null;
      this.multipathToolService.unSelectFeature(i);
      return;
    }
    if(this.multipathToolService.selectedIndex != null)
      this.multipathToolService.unSelectFeature(this.multipathToolService.selectedIndex);
    this.multipathToolService.selectFeature(i);
    this.multipathToolService.selectedIndex = i;
  }
  deleteElement(){
    if(this.multipathToolService.selectedIndex == null)
      return;
    this.multipathToolService.deleteElement(this.multipathToolService.selectedIndex);
    if(this.multipathToolService.multipathElems.length == 0){
      this.multipathToolService.selectedIndex = null;
      return;
    }
    if(this.multipathToolService.selectedIndex > this.multipathToolService.multipathElems.length - 1){
      this.multipathToolService.selectedIndex = this.multipathToolService.multipathElems.length - 1
    }
  }
  deleteAll(){
    this.multipathToolService.selectedIndex = null;
    this.multipathToolService.deleteAll();
  }
  display(){
    if(this.multipathToolService.selectedIndex != null)
      this.multipathToolService.draw(this.multipathToolService.selectedIndex);
  }

}
